<template>
  <div-box>
    <nav-bar left-arrow :title="$t('我的理财明细')" />
    <vant-up-down ref="list" @list="(val) => (list = val)" res="res.data.data" :noToken="false"
      url="/api/v1/user/financial_logs" :data="{ order_id }">
      <div-padding padding="3vw">
        <div-card bg='#242424' padding='3vw' margin="0 0 3vw 0">
          <div class="head">
            <p>{{ $t('时间') }}</p>
            <p>{{ $t('币种') }}</p>
            <p>{{ $t('数量') }}</p>
            <p>{{ $t('类型') }}</p>
          </div>
          <div class="item" v-for="(item, index) in list" :key="index">
            <p>{{ item.created_at }}</p>
            <p>ACT</p>
            <p>+{{ item.num }}</p>
            <text-p>产出</text-p>
          </div>
        </div-card>
      </div-padding>
    </vant-up-down>
  </div-box>
</template>

<script>
  export default {
    data() {
      return {
        order_id: this.urlQuery().id,
        list: [],
      }
    },
    created() {
      this.up_down()
    },
    methods: {
      onClick() {
        this.up_down()
      },
    },
  }
</script>
<style lang='less' scoped>
  .head {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 3px;
    p {
      color: #999;
      font-size: 13px;
      &:nth-child(1) {
        width: 28%;
      }
      &:nth-child(2) {
        width: 15%;
      }
      &:nth-child(3) {
        width: 42%;
        text-align: center;
      }
      &:nth-child(4) {
        width: 15%;
        text-align: right;
      }
    }
  }
  .item {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 12px 0 10px;
    border-bottom: 1px solid #333;
    p {
      color: #fff;
      font-size: 14px;
      &:nth-child(1) {
        width: 28%;
        padding-right: 5px;
      }
      &:nth-child(2) {
        width: 15%;
        font-weight: 550;
      }
      &:nth-child(3) {
        width: 42%;
        text-align: center;
        font-weight: 550;
        padding: 0 3px;
      }
      &:nth-child(4) {
        width: 15%;
        text-align: right;
      }
    }
    &:last-child {
      border-bottom: none;
    }
  }
</style>